<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/tickets";
import Swal from 'sweetalert2'

export default {
  extends: ModelCreate,
  page: {
    title: "Create Tickets",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('tickets.singular')) }},
    resourceRoute: {default: 'tickets'},
    modelVariable: {default: 'tickets'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('tickets.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('tickets.plural')),
          href: "/tickets",
        },
        {
          text: this.$t("Create New"),
          href: "/tickets/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/tickets', value);
    },
    storeSuccessAlert(something, id) {
      return Swal.fire({
        title: this.$t('Success') + '!',
        text: this.$t(`You've added {something} with id {id}`, {something, id}),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
    },
    handleStore(value) {
      this.storing = true;
      this.store(value)
      .then((response) => {
        const { data: { data } } = response
        this.storeSuccessAlert(this.getModelName(value), (data || {}).id)
        return response;
      })
      .then((response) => {
        const { data: { data: { id } } } = response
        this.isEditing = false;

        return this.$router.push({
          path: '/purchase_orders/create',
          query: {
            ticket_id: id,
          }
        })
      })
      .catch((error) => this.failedAlert(error))
      .finally(() => { this.storing = false })
    },
  },
}
</script>
